import { render, staticRenderFns } from "./OtherBusinessKYCInfo.vue?vue&type=template&id=a849f596&scoped=true"
import script from "./OtherBusinessKYCInfo.vue?vue&type=script&lang=js"
export * from "./OtherBusinessKYCInfo.vue?vue&type=script&lang=js"
import style0 from "./OtherBusinessKYCInfo.vue?vue&type=style&index=0&id=a849f596&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a849f596",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a849f596')) {
      api.createRecord('a849f596', component.options)
    } else {
      api.reload('a849f596', component.options)
    }
    module.hot.accept("./OtherBusinessKYCInfo.vue?vue&type=template&id=a849f596&scoped=true", function () {
      api.rerender('a849f596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/businessKYC/components/OtherBusinessKYCInfo.vue"
export default component.exports